// Routes owned by the WorkDay module. Merged into the app-wide `paths` object
// by src/app/paths.ts; see src/modules/README.md.
export const workDayPaths = {
    workdayList: '/account/workdays',
    workdayManage: '/workdays/manage',
} as const
